module.exports = __webpack_public_path__ + "img/findjobs.dfc67411.svg";